/** The conversation frame: thread, steps, embeds and composer chrome. */
export default {
  // Thread
  thinking: "Thinking",
  emptyThread: "This conversation will appear here.",
  loadingConversation: "Loading conversation…",
  addedToTurn: "Added to the current turn",
  copyYourMessage: "Copy your message",
  copyAssistantMessage: "Copy assistant message",
  compactingContext: "Compacting context…",
  question: "Question",
  you: "You",

  // Composer
  sending: "Sending…",
  connecting: "Connecting to the conversation…",
  newChatFailed: "Couldn’t start a new conversation",

  // Work steps
  toolCall: "Tool call",
  toolFailed: "Tool failed",
  desktopInteraction: "Desktop interaction",
  screenshotTakenAfter: "Screenshot taken after",
  worked: "Worked",
  workedFor: "Worked for {duration}",
  durationHours: "{count}h",
  durationMinutes: "{count}m",
  durationSeconds: "{count}s",

  // Results and approvals
  openTask: "Open task",
  taskDone: "Task done",
  openAppFailed:
    "Could not open the app. Check that it is installed and try again.",
  approvalAllowed: "Allowed",
  approvalDenied: "Denied",
  approvalExpired: "Expired: nobody answered in time",
  approvalFailed: "That did not work. Try again.",

  // Filing notices
  filedIn: "Filed in {project}",
  filingUndo: "Undo",
  filingUndone: "Undone",
  filingUndoFailed: "Could not undo that. Please try again.",
  filingMove: "Move",
  filingMoved: "Moved",
  filingAfterRun: "Available once this run ends.",
  filingRename: "Rename",
  filingRenameTitle: "Rename project",
  filingProjectName: "Project name",
  filingRenameFailed: "Could not rename the project.",

  // Connected frames and embeds
  connectedFrames: "Connected frames ({count})",
  noConnectedFrames: "No connected frames",
  untitledArtifact: "Untitled artifact",
  openFrameBeside: "Open frame beside conversation",
  loadingFramePreview: "Loading frame preview",
  embedFallbackLabel: "{title} ({type})",
  frameOfType: "{type} frame",
} as const;
